export default __webpack_public_path__ + "static/illustration-action.url-a37266efb2dbf6211e2c1a6ec4228325.svg";